// API配置文件
const API_CONFIG = {
    // 开发环境配置
    development: {
        baseURL: 'http://localhost:8080',
        timeout: 10000,
        // 后端服务地址
        serverURL: 'http://localhost:8080',
        // 静态资源基础URL
        staticURL: 'http://localhost:8080'
    },

    // 生产环境配置
    production: {
        baseURL: 'https://api-script.pg-code-go.com',
        timeout: 10000,
        // 生产环境后端服务地址，需要根据实际部署情况修改
        serverURL: 'https://api-script.pg-code-go.com',
        // 生产环境静态资源基础URL
        staticURL: 'https://api-script.pg-code-go.com'
    }
}

// 获取当前环境配置
const getCurrentConfig = () => {
    const env = process.env.NODE_ENV || 'development'
    return API_CONFIG[env] || API_CONFIG.development
}

// 导出配置
export default getCurrentConfig()

// 导出API端点常量
export const API_ENDPOINTS = {
    // 分类相关
    CATEGORIES: {
        LIST: '/shop/category/list',
        ACTIVE: '/shop/category/active',
        DETAIL: (id) => `/shop/category/${id}`,
        // 新增层级分类相关端点
        TREE: '/shop/category/tree/frontend',
        TOP_LEVEL: '/shop/category/top-level',
        CHILDREN: (parentId) => `/shop/category/children/${parentId}`,
        BY_LEVEL: (level) => `/shop/category/level/${level}`,
        DESCENDANTS: (categoryId) => `/shop/category/descendants/${categoryId}`
    },

    // 商品相关
    PRODUCTS: {
        BY_CATEGORY: (categoryId) => `/shop/product/category/${categoryId}`,
        HOT: '/shop/product/hot',
        NEW: '/shop/product/new',
        SEARCH: '/shop/product/search',
        DETAIL: (id) => `/shop/product/info/${id}`,
        DEMO_IMAGES: (id) => `/shop/product/demo-images/${id}`,
        UPDATE_DEMO_IMAGES: (id) => `/shop/product/demo-images/${id}`,
        UPLOAD_IMAGE: '/shop/product/image/upload',
        UPLOAD_IMAGES: '/shop/product/image/upload/batch',
        DELETE_IMAGE: '/shop/product/image/delete',
        UPLOAD_COMPRESSED: '/shop/product/image/upload/compressed',
        PREVIEW_IMAGE: '/shop/product/image/preview'
    },

    // 公告相关
    NOTICES: {
        ACTIVE: '/shop/notice/active',
        TOP: '/shop/notice/top'
    },

    // 设置相关
    SETTINGS: {
        ALL: '/shop/setting/all',
        BY_KEY: (key) => `/shop/setting/key/${key}`
    },

    // 产品画廊相关
    GALLERY: {
        LIST: '/shop/gallery/list',
        BY_PRODUCT: (productId) => `/shop/product/gallery/${productId}`,
        FEATURED: (productId) => `/shop/product/gallery/featured/${productId}`,
        COVER: (productId) => `/shop/product/gallery/cover/${productId}`,
        BY_CATEGORY: (productId, category) => `/shop/product/gallery/category/${productId}/${category}`,
        STATS: (productId) => `/shop/product/gallery/stats/${productId}`,
        DETAIL: (galleryId) => `/shop/gallery/${galleryId}`,
        ADD: '/shop/gallery',
        UPDATE: '/shop/gallery',
        DELETE: (galleryIds) => `/shop/gallery/${galleryIds}`,
        UPDATE_SORT: '/shop/gallery/sort',
        SET_COVER: (productId, galleryId) => `/shop/gallery/cover/${productId}/${galleryId}`,
        UNSET_COVER: (productId) => `/shop/gallery/cover/${productId}`,
        TOGGLE_FEATURED: (galleryId) => `/shop/gallery/featured/${galleryId}`,
        BATCH_IMPORT: (productId) => `/shop/gallery/import/${productId}`,
        COPY_GALLERY: (sourceId, targetId) => `/shop/gallery/copy/${sourceId}/${targetId}`,
        SET_TAGS: (galleryId) => `/shop/gallery/tags/${galleryId}`,
        ADD_TAGS: (galleryId) => `/shop/gallery/tags/${galleryId}`,
        REMOVE_TAGS: (galleryId) => `/shop/gallery/tags/${galleryId}`,
        // 画廊图片上传相关API
        UPLOAD_IMAGE: '/shop/gallery/image/upload',
        UPLOAD_IMAGES: '/shop/gallery/image/upload/batch',
        UPLOAD_COMPRESSED: '/shop/gallery/image/upload/compressed',
        DELETE_IMAGE: '/shop/gallery/image/delete'
    }
}
